<template>
  <v-row>
    <PageHeaderDesktop />
    <TopMenu v-if="!$store.state.showArticleOnly" />
  </v-row>
</template>

<script>
import TopMenu from '@/components/App/TopMenu'
import PageHeaderDesktop from '@/components/App/Header/PageHeaderDesktop'

export default {
  name: 'DesktopTopPart',

  components: {
    PageHeaderDesktop,
    TopMenu,
  },
}
</script>
